import { render, staticRenderFns } from "./AssessmentGroupEmbargoDates.vue?vue&type=template&id=7ef80f79&scoped=true"
import script from "./AssessmentGroupEmbargoDates.vue?vue&type=script&lang=js"
export * from "./AssessmentGroupEmbargoDates.vue?vue&type=script&lang=js"
import style0 from "./AssessmentGroupEmbargoDates.vue?vue&type=style&index=0&id=7ef80f79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef80f79",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
